import {
  disableSuggestCreateInvestmentVehicleModal,
  getIsShowSuggestCreateInvestmentVehicleModalEnabled,
  getShowSuggestCreateInvestmentVehicleModal,
  getSuggestedInvestor,
  setShowSuggestCreateInvestmentVehicleModal,
} from 'features/investorManagementSlice'

import { BasicSubjectFragment } from 'types/graphql-schemas/graphql'
import { useAppDispatch, useAppSelector } from './reduxToolkit'

export const useSuggestCreateInvestmentVehicleModal = () => {
  const dispatch = useAppDispatch()
  const showSuggestionModal = useAppSelector(
    getShowSuggestCreateInvestmentVehicleModal
  )

  const suggestedInvestor = useAppSelector(getSuggestedInvestor)

  const isSuggestionModalEnabled = useAppSelector(
    getIsShowSuggestCreateInvestmentVehicleModalEnabled
  )

  const disableSuggestionModal = () => {
    dispatch(disableSuggestCreateInvestmentVehicleModal())
  }

  const setSuggestionModalData = (investor: BasicSubjectFragment) => {
    dispatch(
      setShowSuggestCreateInvestmentVehicleModal({ show: true, investor })
    )
  }

  const closeSuggestionModal = () => {
    dispatch(setShowSuggestCreateInvestmentVehicleModal({ show: false }))
  }

  return {
    showSuggestionModal,
    closeSuggestionModal,
    suggestedInvestor,
    isSuggestionModalEnabled,
    disableSuggestionModal,
    setSuggestionModalData,
  }
}
